import { Box, Group, Text } from '@mantine/core';
import type { ReactElement } from 'react';
import { SurfaceCard } from '@/design/SurfaceCard';

interface AIExplorerTilePlaceholderProps {
    /** The slot's role, shown faintly so the awaiting tile reads as intentional. */
    label?: string;
    /** Minimum body height so the slot holds its shape before the tile arrives. */
    minHeight?: number;
}

/**
 * The empty-slot placeholder shown while a tile config is still streaming in (or
 * its data is loading). Matches the {@link SurfaceCard} geometry and shimmers so
 * the slot reads as "incoming content" rather than broken. The shimmer is
 * disabled under `prefers-reduced-motion` (see global.css).
 */
export default function AIExplorerTilePlaceholder({ label, minHeight = 160 }: AIExplorerTilePlaceholderProps): ReactElement {
    return (
        <SurfaceCard $padding="md" $borderless style={{ height: '100%' }}>
            <Group justify="space-between" align="center" mb="sm" wrap="nowrap">
                <Box className="bm-shimmer" style={{ height: 12, width: '45%', borderRadius: 4 }} />
                <Box className="bm-shimmer" style={{ height: 12, width: 28, borderRadius: 4 }} />
            </Group>
            <Box className="bm-shimmer" style={{ flex: 1, minHeight, borderRadius: 'var(--bm-radius)' }} />
            {label !== undefined && (
                <Text size="xs" c="dimmed" mt="sm" ta="center" tt="uppercase" fw={700} style={{ fontSize: '9px', letterSpacing: '0.08em' }}>
                    {label}
                </Text>
            )}
        </SurfaceCard>
    );
}
